import timeTracking from '$$timeTrackingModel';

function onTaskTimeLogDeleted(event) {
  const items = event.innerSettings.collaborationItems;
  const gantt_id = event.innerSettings.gantt_id;
  const task_id = event.innerSettings.task_id;

  timeTracking.manualUpdateItemForTask({
    task_id,
    gantt_id,
  }, items);
}

export default onTaskTimeLogDeleted;
